import apiConfig from "../config/api";
import { get, post, requestDelete, put } from "../helpers/request";
import { removeDiacritics } from '../helpers/string.lib';

const apiRoles = `${apiConfig.apiUri}api/accessmanagement/rol`;
const rolesUser = `${apiConfig.apiUri}api/accessmanagement/assignment/rol`;
const apiPortalEmpresa = `${apiConfig.apiUri}api/portalmanagement/portalempresa`;

export const allRolesByProfileId = (idProfile) =>
  get(`${apiRoles}/get/${idProfile}`);

export const overrideRolesForUser = (
  Rut,
  RelationTypeCode,
  CompanyRut,
  IdRoles,
  isPortalExterno
) =>
  post(`${rolesUser}/user/company/create/override`, {
    body: JSON.stringify({
      Rut,
      RelationTypeCode,
      CompanyRut,
      IdRoles,
      isPortalExterno,
    }),
  });

export const createRolesForUserAndCompany = (
  Rut,
  CompanyRut,
  RelationTypeCode,
  IdRoles
) =>
  post(`${rolesUser}/user/company/create`, {
    body: JSON.stringify({
      Rut,
      CompanyRut,
      RelationTypeCode,
      IdRoles,
    }),
  });

export const createRolesForUser = (Rut, IdRoles) =>
  post(`${rolesUser}/user/create`, {
    body: JSON.stringify({
      Rut,
      IdRoles,
    }),
  });

export const createUserByRol = (idRol, companyRut, users) =>
  post(`${rolesUser}/users/company/create`, {
    body: JSON.stringify({
      IdRol: idRol,
      CompanyRut: companyRut,
      UsersRelations: users,
    }),
  });

export const deleteRolesByUser = (data) =>
  requestDelete(`${rolesUser}/delete/user/${data.Rut}`, {
    body: JSON.stringify({
      IdRoles: data.idRoles,
    }),
  });

//export const getEmplyeesByCompanyRut = (companyRut) => get(`${apiConfig.apiUri}api/company/get/employees/${companyRut}`);
export const getEmplyeesByCompanyRut = (
  companyRut,
  page = 1,
  size = 10,
  filter = "",
  filterRoles = [],
  myRoles = []
) =>
  {
    myRoles = myRoles.map(removeDiacritics);
    // return get(`https://localhost:44331/api/company/get/employees/${companyRut}?page=${page}&size=${size}&filter=${filter}`, { headers: { roles: myRoles }});
    return get(`${apiConfig.apiUri}api/company/get/employees/${companyRut}?page=${page}&size=${size}&filter=${filter}`, {
      headers: {
        roles: myRoles,
        filterRoles
      }
    });
  }

const stringToArrayBuffer = dataString => {
  const buf = new ArrayBuffer(dataString.length)
  const view = new Uint8Array(buf)

  for (let i = 0; i != dataString.length; ++i) view[i] = dataString.charCodeAt(i) & 0xFF;

  return buf
}

export const getExcelFile = async (companyRut, filter = '', filterRoles = [], myRoles = []) => {
  myRoles = myRoles.map(removeDiacritics);

  let url = `${apiConfig.apiUri}api/company/file/generate/${companyRut}?roles=${myRoles.join('&roles=')}&filter=${filter}`
  url = filterRoles.length > 0 ? `${url}&filterRoles=${filterRoles.join('&filterRoles=')}` : url

  const getToken = () => localStorage.getItem("AccessToken");
  const xhr = new XMLHttpRequest()
  xhr.open('GET', url)
  xhr.setRequestHeader('Content-Type', 'text/plain')
  xhr.setRequestHeader('Ocp-Apim-Subscription-Key', apiConfig.OcpApimSubscriptionKey)
  xhr.setRequestHeader('Authorization', `Bearer ${getToken()}`)
  xhr.onload = () => {
    const bin = atob(xhr.response)
    const ab = stringToArrayBuffer(bin)
    const blob = new Blob([ab], { type: 'application/vnd.ms-excel;base64' })

    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = 'Datagrid.xlsx'

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
  xhr.send()

  //window.open(url)
}

export const getRolesByCompanyRutAndUser = (companyRut, userRut) =>
  get(`${apiConfig.apiUri}api/company/get/employee/${companyRut}/${userRut}`)

export const getExternalEmployees = (companyRut) =>
  get(
    `${apiConfig.apiUri}api/notifications/external/assignment/get/subscribers/${companyRut}`
  );

export const getUserRolesPortalEmpresa = (userRut) =>
  get(`${apiPortalEmpresa}/user/${userRut}`);

export const getAllRolesPortalEmpresa = () =>
  get(`${apiPortalEmpresa}/rol`, {
    params: {
      rolName: "*",
    },
  });

export const getAllGruposPortalEmpresa = () =>
  get(`${apiPortalEmpresa}/group`, {
    params: {
      groupName: "*",
    },
  });

export const createPortalEmpresaForUser = (userData) =>
  post(`${apiPortalEmpresa}/user/create`, {
    body: JSON.stringify(userData),
  });

export const updatePortalEmpresaForUser = (userData) =>
  put(`${apiPortalEmpresa}/user/update`, {
    body: JSON.stringify(userData),
  });

export const deletePortalEmpresaForUser = (userId) =>
  requestDelete(`${apiPortalEmpresa}/delete/${userId}`);

export const deleteRolesTrabajador = async (data) => {
  requestDelete(`${rolesUser}/user/company/delete?userRut=${data.rut}&userCompanyRut=${data.companyRut}`)
};
